/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import { Progress } from 'antd';
import { useQuery } from '../../hooks/useQuery';
import { ReactComponent as SelectedSub } from './img/sub-cat-selected.svg';
import { ReactComponent as FilledSub } from './img/sub-cat-filled.svg';
import { ReactComponent as UnselectedSub } from './img/sub-cat-unselected.svg';
import { ReactComponent as CatSelected } from './img/cat-selected.svg';

const CategoryItem = ({ t, name, selected, category, selectedIndex, validateCategory }) => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const hasAutoSelected = useRef(false);

  const { onboardingById } = useSelector(state => state.onboardingReducer);
  const currentIndex = category?.group_order-1;

  const query = useQuery(search);
  const subCategory = query.get('sub-category');

  const handleSelectSubCategory = (e, id) => {
    e.stopPropagation();
    const newQuery = new URLSearchParams(search);
    newQuery.set('sub-category', id);
    history.replace({
      pathname,
      search: `?${newQuery.toString()}`,
    });
  };

  useEffect(() => {
    if (!selected) {
      hasAutoSelected.current = false;
    }
  }, [selected]);

  useEffect(() => {
    if (selected && !subCategory && category && category?.subCategory?.length > 0 && !hasAutoSelected.current) {
      hasAutoSelected.current = true;
      const newQuery = new URLSearchParams(search);
      newQuery.set('sub-category', category?.subCategory[0].id);
      history.replace({
        pathname,
        search: `?${newQuery.toString()}`,
      });
    }
    
  }, [selected, subCategory, category, search, pathname, history]);

  const getTotalElements = useMemo(() => {
    let filled = 0;
    let subFilled = {};
    if(category?.subCategory?.length > 0 && onboardingById) {
      const total = category?.subCategory
      ?.reduce((acc, item) => acc + item.form_elements.filter(element => element?.form_action_element?.type !== 'GENERAL' && element?.form_input_element?.type !==  'NONE').length, 0);
      category.subCategory.forEach(item => {
          let totalSub = {[item?.id]: 0};
          item.form_elements.forEach(element => {
            if(Object.hasOwn(element, 'form_input_element')) {
              const stored = onboardingById.form_input_element_submissions
              ?.find(i => i.form_input_element_id === element?.form_input_element?.id &&
                element?.form_action_element?.type !== 'GENERAL' && element?.form_input_element?.type !==  'NONE');
                if(stored) {filled++; totalSub[item?.id]++;}
            } else if (Object.hasOwn(element, 'form_composite_input_element')) {
              const stored = onboardingById.form_composite_input_element_submissions
                ?.find(i => i.form_composite_input_element_id === element?.form_composite_input_element?.id &&
                element?.form_action_element?.type !== 'GENERAL');
                if(stored) {filled++; totalSub[item?.id]++;}
            }
          });
          subFilled = {...subFilled, ...totalSub};
        }
      );

      return {filled, total, subFilled};
    } else {
      const total = category?.form_elements?.filter(element => element?.form_action_element?.type !== 'GENERAL' && element?.form_input_element?.type !==  'NONE').length || 0;
      if(onboardingById) {
        category.form_elements.forEach(item => {
          if(Object.hasOwn(item, 'form_input_element')) {
            const stored = onboardingById.form_input_element_submissions
              ?.find(i => i.form_input_element_id === item?.form_input_element?.id &&
                item?.form_action_element?.type !== 'GENERAL' && item?.form_input_element?.type !==  'NONE');
            if(stored) {filled++;}
          } else if (Object.hasOwn(item, 'form_composite_input_element')) {
            const stored = onboardingById.form_composite_input_element_submissions
              ?.find(i => i.form_composite_input_element_id === item?.form_composite_input_element?.id &&
                item?.form_action_element?.type !== 'GENERAL' && item?.form_input_element?.type !==  'NONE');
            if(stored) {filled++;}
          }
        }
        );
        return {filled, total};
      }
    }
  }, [category, onboardingById]);

  useEffect(() => {
    console.log('getTotalElements',getTotalElements);
  }, [getTotalElements]);
  
  const getFilledStatus = (id) => {
    const element =  validateCategory?.subCategory?.find( i => i.id === id);
    const result = element?.mandatory === element?.filledMandatory ? 'completed' : '';
    console.log('🚀 ~ getFilledStatus ~ result:', result);
    return result;
  };

  return (
    <>
      <div className={selected ? 'category-item selected' : 'category-item'}>
        <div className="category-colunm">
          <div
            className={
              `category-checkbx ${currentIndex === selectedIndex ? 'full' : ''}${validateCategory?.filledMandatory === validateCategory?.mandatory ? ' completed' : ''}`}
          />
          <p className="category-name">{t(name)}</p>
        </div>
        <div className="category-counter-wrapper">
          <div className="category-counter">
            <span className='category-counter-filled'>{getTotalElements?.filled}</span><span style={{fontSize: '20px', lineHeight: '24px'}}>/</span>
            <span className='category-counter-total'>{getTotalElements?.total}</span>
          </div>
          {selected && <CatSelected />}
        </div>
        <Progress 
            className='table-date-progress'
            percent={getTotalElements?.total > 0 
              ?( getTotalElements?.filled * 100 / getTotalElements?.total).toFixed(2) 
              : 0} 
            showInfo={false} 
            strokeColor={'#FB7B34'}
            size={{height: 2}}
          />
      </div>
      {selected && category?.subCategory?.length > 0 &&
        category?.subCategory?.map((i) => (
          <div
            className={`category-sub-item ${subCategory === i.id ? 'selected' : ''}`}
            key={i.id}
            onClick={(e) => handleSelectSubCategory(e, i.id)}
          >
            <div className='category-sub-item-title'>
              {getFilledStatus(i?.id) === 'completed' 
                ? <FilledSub /> 
                : subCategory === i.id 
                  ? <SelectedSub /> 
                  : <UnselectedSub />
                }
              <p>{i.description}</p>
            </div>
            <div className="category-counter">
              <span className='category-counter-filled'>{getTotalElements?.subFilled[i?.id] || 0}</span><span style={{fontSize: '20px', lineHeight: '24px'}}>/</span>
              <span className='category-counter-total'>{i?.form_elements?.filter(element => element?.form_action_element?.type !== 'GENERAL').length || 0}</span>
            </div>
          </div>
        ))}
    </>
  );
};

export default CategoryItem;

CategoryItem.propTypes = {
  t: PropTypes.func,
  category: PropTypes.object,
  name: PropTypes.string,
  selectedIndex: PropTypes.number,
  selected: PropTypes.bool,
  validateCategory: PropTypes.object,
};
